<template>
  <iframe style="position:fixed; top:0; left:0; bottom:0; right:0; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;"></iframe>
</template>

<script>

const pdfMake = require("pdfmake/build/pdfmake.js");
const pdfFonts = require("pdfmake/build/vfs_fonts.js");
const moment = require('moment');
pdfMake.vfs = pdfFonts.pdfMake.vfs;
const countryList = require('country-list');

export default {
  name: 'InvoicePDF',
  created() {
    fetch(process.env.VUE_APP_API + '/invoices/' + this.$route.params.invoiceId, {
      method: 'get',
      credentials: 'include',
      headers: {
        "Content-type": "application/json",
        "Accept": "application/json",
        "Accept-Charset": "utf-8",
        'CSRF-Token': this.$csrf
      }
    })
    .then(response => {
      return response.json();
    })
    .then(invoice => {
      if(!invoice.err){
        return this.generate(invoice);
      }
      console.log(invoice.err);
    });
  },
  methods: {
    generate(invoice) {
      let services = [
        [
          'Storitev',
          { 'text': 'Kol', 'noWrap': true, 'bold': true},
          { 'text': 'Cena', 'noWrap': true, 'bold': true},
          { 'text': 'DDV', 'noWrap': true, 'bold': true},
          { 'text': 'Cena z DDV', 'noWrap': true, 'bold': true},
          { 'text': 'Popust', 'noWrap': true, 'bold': true},
          { 'text': 'Vrednost EUR', 'noWrap': true, 'bold': true}
        ],
      ];

      let minDate = invoice.services.reduce((a,b) => a.date.start < b.date.start ? a : b);
      let maxDate = invoice.services.reduce((a,b) => a.date.end > b.date.end ? a : b);

      console.log("datumi")
      console.log(minDate.date.start);
      console.log(maxDate.date.end)

      let serviceDate = minDate.date.start == maxDate.date.end ? moment(minDate.date.start).format('DD.MM.YYYY') : moment(minDate.date.start).format('DD.MM.YYYY') + ' - ' + moment(maxDate.date.end).format('DD.MM.YYYY')

      let netAmount = 0;
      let taxAmount = 0;
      let taxBase = 0;
      let discountAmount = 0;
      invoice.services.forEach(service => {
        netAmount += service.price * service.quantity * (100 / (100 + service.taxRate));
        taxAmount += service.price * service.quantity * (service.taxRate / (100 + service.taxRate));
        if(service.taxRate == 9.5){
          taxBase += netAmount;
        }

        discountAmount += (service.price - service.fullPrice) * service.quantity;
        services.push([
          service.title,
          service.quantity,
          (Math.round(service.fullPrice * (100 / (100 + service.taxRate)) * 100 + Number.EPSILON) / 100).toFixed(2),
          (Math.round(service.fullPrice * (service.taxRate / (100 + service.taxRate)) * 100 + Number.EPSILON) / 100).toFixed(2) + '(' + service.taxRate + '%)',
          service.fullPrice.toFixed(2),
          Math.round(((1 - (service.price / service.fullPrice)) * 100 * 100 + Number.EPSILON) / 100) + '%',
          {
            'text': (Math.round((service.price * service.quantity *  100) + Number.EPSILON) / 100).toFixed(2),
            'alignment': 'right'
          }
        ]);
      });

      let paymentMethods = [['', {"text": "Plačano:", "bold": true}, '', (Math.round((netAmount + taxAmount) * 100 + Number.EPSILON) / 100).toFixed(2)]];
      invoice.paymentMethods.forEach(method => {
        paymentMethods.push([
          '', method.title+":", '', {'text': method.amount.toFixed(2), 'alignment': 'right'}
        ])
      })

      var docDefinition = {
        info: {
          title: invoice.premise.label + '-' + invoice.device.label + '-' + invoice.index,
        },
        'content': [
          {
            'margin': [ 0, 0, 0, 30 ],
            'stack': [
              {
                'text': invoice.premise.title,
                'fontSize': 15,
                'bold': true
              },
              invoice.premise.address.street + ' ' + invoice.premise.address.houseNumber + (invoice.premise.address.additionalNumber || ''),
              invoice.premise.address.postalCode + ' ' + invoice.premise.address.city,
              'Identifikacijska številka: ' + invoice.premise.idNumber,
              'Matična številka: ' + invoice.premise.registerNumber,
              'TRR: ' + invoice.premise.trr
            ]
          },

          {
            'layout': 'noBorders',
            'table': {
              'headerRows': 0,
              'widths': [ '*', '*' ],
              'body': [
                [
                  {
                    'margin': [ 0, 0, 0, 20 ],
                    'stack':
                      invoice.payer
                      ?
                      [
                        invoice.payer.title || '/',
                        invoice.payer.address || '/',
                        invoice.payer.city || '/',
                        countryList.getData().find(c => c.code == invoice.payer.country) ? countryList.getData().find(c => c.code == invoice.payer.country).name : '/',
                        invoice.payer.vat ? { text: 'Identifikacijska številka: ' + invoice.payer.vat, margin: [ 0, 30, 0, 20 ] } : ''
                      ]
                      :
                      ['/', '/']
                  },
                  {
                    'margin': [ 0, 0, 0, 20 ],
                    'stack': [
                      { 'text': 'RAČUN', 'bold': true, 'fontSize': 22 },
                      {
                        'layout': 'noBorders',
                        'table': {
                          'headerRows': 0,
                          'widths': [ '*', '*' ],
                          'body': [
                            [{ 'text': 'Številka računa:', 'bold': true }, { 'text': invoice.premise.label + '-' + invoice.device.label + '-' + invoice.index, 'bold': true}],
                            [{ 'text': 'Kraj:', 'bold': true }, invoice.premise.address.city],
                            [{ 'text': 'Datum:', 'bold': true }, moment(invoice.issued.date).format('DD.MM.YYYY') + ' ' + invoice.issued.time],
                            [{ 'text': 'Opravljeno:', 'bold': true }, serviceDate],
                          ]
                        }
                      }
                    ]
                  }
                ],
              ]
            }
          },

          {
            'layout': 'lightHorizontalLines', // optional
            'table': {
              'headerRows': 1,
              'widths': [ '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto' ],
              'body': services
            }
          },
          {canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 } ]},
          {
            'layout': 'noBorders',
            'table': {
              'headerRows': 0,
              'widths': [ 300, '*', '*', 'auto' ],
              'body': [
                ['', {'text': 'Skupaj', 'bold': true}, discountAmount ? '(Popust ' + discountAmount.toFixed(2) + ')' : '', {'text': (Math.round(netAmount * 100 + Number.EPSILON) / 100).toFixed(2), 'alignment': 'right'}],
                ['', {'text': 'DDV (9,5%)', 'bold': true}, 'od: ' + taxBase.toFixed(2), {'text':  (Math.round(taxAmount * 100 + Number.EPSILON) / 100).toFixed(2), 'alignment': 'right'}],
                ['', {'text': 'Skupaj EUR', 'bold': true}, '', {'text':  (Math.round((netAmount + taxAmount) * 100 + Number.EPSILON) / 100).toFixed(2), 'alignment': 'right'}]
              ]
            }
          },
          {canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 } ]},
          {
            'margin': [ 0, 0, 0, 20 ],
            'layout': 'noBorders',
            'table': {
              'headerRows': 0,
              'widths': [ 300, '*', '*', 'auto' ],
              'body': paymentMethods
            }
          },
          {
            'margin': [ 0, 0, 0, 20 ],
            'layout': 'noBorders',
            'table': {
              'headerRows': 0,
              'widths': [ '*', '*'],
              'body': [
                [
                  {
                    'margin': [ 0, 0, 0, 60 ],
                    'stack': [
                      {
                        'text': [
                          { 'text': 'EOR: ', 'bold': true },
                          invoice.eor
                        ]
                      },
                      {
                        'text': [
                          { 'text': 'ZOI: ', 'bold': true },
                          invoice.zoi
                        ]
                      }
                    ]
                  },

                  {
                    'margin': [ 0, 0, 0, 20 ],
                    'alignment': 'right',
                    'text': [
                      { 'text': 'Blagajnik: ', 'bold': true },
                      invoice.cachier.name.first + ' ' + invoice.cachier.name.last
                    ]
                  },
                ]
              ]
            }
          },
          {
            'margin': [ 0, 0, 0, 10 ],
            'alignment': 'center',
            'qr': invoice.qr,
            fit: '50'
          },
          {
            'alignment': 'center',
            'text': '',
          }
        ],
        defaultStyle: {
          fontSize: 10,
        }
      };

      const pdfDocGenerator = pdfMake.createPdf(docDefinition);
      pdfDocGenerator.getDataUrl((dataUrl) => {
      	const iframe = document.querySelector('iframe');
      	iframe.src = dataUrl;
      });
    }
  }
}
</script>
